// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","exclude_mobile":"(min-width: 601px)","contactsSection":"contactsSection-3uxBM","input":"input-3mW94"};